import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';
import {
  HorizontalFlex,
  VerticalFlex,
} from '@components/RecordCard/RecordCard.style';

import type { LabResultObservationRecord } from '@models/lab-result';
import type { VitalSignObservationRecord } from '@models/vital-sign';

import {
  getBloodTypeDisplay,
  getHeightDisplay,
  getWeightDisplay,
} from '@utils/records';

// import { EXTENDED_PROFILE_ID } from '@constants/survey-ids';
import { InfoH2, TitleH2 } from '@views/HealthSummary/HealthSummary.style';

const messages = defineMessages({
  bloodType: {
    id: 'extendedSection.bloodType',
    defaultMessage: 'Blood Type',
  },
  height: {
    id: 'extendedSection.height',
    defaultMessage: 'Height',
  },
  weight: {
    id: 'extendedSection.weight',
    defaultMessage: 'Weight',
  },
  unknown: {
    id: 'GLOBAL.unknown',
    defaultMessage: 'Unknown',
  },
  kg: {
    id: 'extendedSection.kg',
    defaultMessage: 'kg',
  },
  lb: {
    id: 'extendedSection.lb',
    defaultMessage: 'lb',
  },
  cm: {
    id: 'extendedSection.cm',
    defaultMessage: 'cm',
  },
  in: {
    id: 'extendedSection.in',
    defaultMessage: 'in',
  },
  ft: {
    id: 'extendedSection.ft',
    defaultMessage: 'ft',
  },
});

interface ExtendedSectionProps {
  height?: VitalSignObservationRecord;
  weight?: VitalSignObservationRecord;
  bloodType?: LabResultObservationRecord | null;
  loading?: boolean;
}

function ExtendedSection({
  height,
  weight,
  bloodType,
  loading = false,
}: ExtendedSectionProps) {
  const { formatMessage } = useIntl();
  const unknownText = formatMessage(messages.unknown);

  const heightDisplay = getHeightDisplay(height) ?? unknownText;
  const weightDisplay = getWeightDisplay(weight) ?? unknownText;
  const bloodTypeDisplay = getBloodTypeDisplay(bloodType) ?? unknownText;

  return (
    <ContentLoader loading={loading}>
      <HorizontalFlex marginBottom={0} marginTop={0} width="100%">
        <VerticalFlex
          alignItems="flex-start"
          justifyContent="flex-start"
          style={{ width: '80px' }}
        >
          <TitleH2>{formatMessage(messages.bloodType)}</TitleH2>
          {bloodTypeDisplay}
          {/* <InfoH2>
            {record.getOption(
              'blood-type',
              survey,
              formatMessage(messages.unknown)
            )}
          </InfoH2> */}
        </VerticalFlex>

        <VerticalFlex
          alignItems="flex-start"
          justifyContent="flex-start"
          style={{ width: '80px' }}
        >
          <TitleH2>{formatMessage(messages.height)}</TitleH2>
          <InfoH2>{heightDisplay}</InfoH2>
        </VerticalFlex>

        <VerticalFlex
          alignItems="flex-start"
          justifyContent="flex-start"
          style={{ width: '80px' }}
        >
          <TitleH2>{formatMessage(messages.weight)}</TitleH2>
          <InfoH2>{weightDisplay}</InfoH2>
        </VerticalFlex>
      </HorizontalFlex>
    </ContentLoader>
  );
}

export default ExtendedSection;
